import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, TextBox } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);


  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <ImageMedia src={require('./assets/1.png')} />
          <MotionContent imgRef={heroRef} height={"110vh"} className="bg-black">
            <ImageMedia
              key={"heroJewoh"}
              src={require('./assets/TEWTickets_Imprimables.jpg')}
              className="relative md:landscape:scale-[120%] full object-cover object-center"
            />
          </MotionContent>


          <div className='flex flex-col lg:flex-row items-start justify-start w-full relative h-fit lg:h-[200vh] bg-blakk'>
            <div className='relative lg:h-full w-full lg:w-2/5 pb-16 paddingX '>
              <TextBox vertical
                padded resp className={"w-fit sticky top-0 pt-16 text-pretty"}
                title={"Système de billeterie — le réel nerf du projet"}
                descr={<>Doté d'un QR CODE <span><i className='ri-qr-code-line' /></span> unique, la méthode effective et efficiente que nous avons utilisé de par notre volonté de prendre en considération chaque détail.

                  <span className='text-white inline-flex flex-col paddingY space-y-2 '>
                    <span><span className='bulletList'>+</span>QR code unique</span>
                    <span><span className='bulletList'>+</span>Variations designs par classe de ticket</span>
                    <span><span className='bulletList'>+</span>Différentiations classes</span>
                  </span>
                </>}
              />
            </div>

            <div id="slidingContent" className='w-full flex flex-col relative h-[200vh]'>
              <div className='bg-black w-full relative flex flex-col'>
                <ImageMedia src={require(`./assets/TT_YoussouNdour.jpg`)} className={"relative"} />
                <div className='grid grid-cols-2 w-full items-center relative'>
                  <ImageMedia src={require(`./assets/TT_Bal_01_LAWWD.jpg`)} className={"relative"} />
                  <ImageMedia src={require(`./assets/TT_Bal_02_LAWWD.jpg`)} className={"full object-cover"} />
                </div>
              </div>

            </div>

          </div>


          {/* FOR LATER */}
          <MotionContent imgRef={heroRef} height={"h-[110vh]"} className="bg-blakk">
            <ImageMedia
              key={"heroTT"}
              src={require('./assets/TEWTickets_Imprimables.jpg')}
              className="relative md:landscape:scale-[120%] full object-cover object-center"
            />
          </MotionContent>


        </div>
      )}
    </ThisProject>
  )
}

export default Content